import * as React from 'react';
import * as ResizablePrimitive from 'react-resizable-panels';

import { cn } from '@/lib/utils';

function ResizablePanelGroup({
	className,
	...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
	return (
		<ResizablePrimitive.PanelGroup
			data-slot="resizable-panel-group"
			className={cn(
				'flex h-full w-full data-[panel-group-direction=vertical]:flex-col',
				className
			)}
			{...props}
		/>
	);
}

function ResizablePanel({
	...props
}: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
	return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
	withHandle, // Deprecated: no longer used, kept for backward compatibility
	className,
	...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
	/** @deprecated No longer used - modern design is always applied */
	withHandle?: boolean;
}) {
	return (
		<ResizablePrimitive.PanelResizeHandle
			data-slot="resizable-handle"
			className={cn(
				'group relative flex items-center justify-center bg-transparent hover:bg-blue-500/10 focus-visible:ring-ring focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-hidden transition-colors duration-200',
				// Horizontal divider (default)
				'w-1 cursor-col-resize',
				// Vertical divider
				'data-[panel-group-direction=vertical]:h-1 data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:cursor-row-resize',
				className
			)}
			{...props}
		>
			{/* Modern subtle line indicator */}
			<div
				className={cn(
					'bg-border/40 group-hover:bg-blue-500/50 transition-colors duration-200',
					// Horizontal line
					'h-8 w-px',
					// Vertical line
					'data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-8',
					// Center the line in the parent
					'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
					'data-[panel-group-direction=vertical]:left-1/2 data-[panel-group-direction=vertical]:top-1/2'
				)}
			/>
		</ResizablePrimitive.PanelResizeHandle>
	);
}

export { ResizableHandle, ResizablePanel, ResizablePanelGroup };
